import { combineReducers } from 'redux';

import workHoursReducer from './workHoursReducer';
import workHoursExportReducer from './workHoursExportReducer';

export default combineReducers({
  workHours: workHoursReducer,
  export: workHoursExportReducer
});
